module.exports = __webpack_public_path__ + "img/amex.1be138a4.svg";